import {useRef, useState} from "react"
import {Badge, Menu, MenuItem, ToggleButton} from "@mui/material"
import {FormatSize} from "@mui/icons-material"

const headings = [ 1, 2, 3 ]
const headingMap = {
	1: "h1",
	2: "h2",
	3: "h3",
}

export function HeadingMenu({editor, editorState}) {
	const [anchorEl, setAnchorEl] = useState(null)
	const menuOpen = Boolean(anchorEl)
	const headingMenuRef = useRef(null)

	const handleToggleHeading = (heading) => {
		if(headings.includes(heading)) {
			editor.chain().focus().toggleHeading({ level: heading }).run()
		}
		setAnchorEl(null)
	}

	const handleToggleNoHeading = () => {
		editor.chain().focus().setParagraph().run()
		setAnchorEl(null)
	}

	return (
		<div>
			<Badge
				invisible={(
					editorState.isHeading === false ||
					editor.getAttributes("heading").level > 3 // currently, we only support 3 levels of headdings
				)}
				badgeContent={editor.getAttributes("heading").level}
				overlap={"circular"}
				anchorOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				//color={"tertiary"}
				sx={{
					"& .${badgeClasses.badge}": {
						top: "-10px",
						right: "-10px",
					},
					"& .MuiBadge-badge": {
						backgroundColor: "notes.moveNoteIndicator",
						color: "RBOneFont.main"
					}
				}}
			>
				<ToggleButton
					value={"na"}
					selected={editor.isActive("heading")}
					className={editor.isActive("heading") ? "Mui-selected" : ""}
					onClick={(e) => setAnchorEl(e.currentTarget)}
					ref={headingMenuRef}
				>
					<FormatSize />
				</ToggleButton>
			</Badge>
			<Menu
				open={menuOpen}
				onClose={() => setAnchorEl(null)}
				anchorEl={headingMenuRef.current}
				variant={"selectedMenu"}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				sx={{
					"& .MuiMenu-list": {
						padding: 0
					}
				}}
			>
				<MenuItem
					dense
					onClick={handleToggleNoHeading}
					selected={!editor.isActive("heading")}
					sx={{
						"& .MuiMenuItem-root.Mui-selected": {
							backgroundColor: "notes.moveNoteIndicator",
						}
					}}
				>
					No heading
				</MenuItem>
				{headings.map((heading) => (
					<MenuItem
						dense
						key={heading}
						onClick={() => handleToggleHeading(heading)}
						selected={
							(editor.isActive("heading") && editor.getAttributes("heading").level === heading)
						}
						component={headingMap[heading]}
						sx={{
							"& .MuiMenuItem-root.Mui-selected": {
								backgroundColor: "notes.moveNoteIndicator",
							}
						}}
					>
						Heading {heading}
					</MenuItem>
				))}
			</Menu>
		</div>
	)
}